import { chakra } from "@chakra-ui/react";
import NextLink from "next/link";

export default chakra(NextLink);
